import { useState } from 'react';
import './thought.css';

import MyThought from "../../data/thought.json"
import ThoughtCard from '../../Components/card/ThoughtCard';

export default function Thought() {
    
    return (
        <div className="team">
            <div className="container">
                <div className="teamTitle">
                    <h2 className='titleHead'>My thought</h2>
                    <p className="titleDoc">{" "}what i think{" "}</p>
                </div>

                <div className="allworkItems">
                    {
                        MyThought?.thoughts.sort((a, b) => b.id - a.id).map((thought) => {
                            return (
                                <ThoughtCard key={thought?.id} thought={ thought } />
                            )
                        })
                    }
                </div>

            </div>
        </div>
    );
}
